import React from "react";

import { Box, Fab, Paper, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import { Cancel, Clear } from "@material-ui/icons";
import { UnidadeContext } from "../../Providers/unidadeProviders";

const Autocomplete = ({ lang }) => {

    const [searchtext, setSearchtext] = React.useState("");
    const [suggest, setSuggest] = React.useState([]);
    const [resfound, setResfound] = React.useState(true);

    const { state, setState } = React.useContext(UnidadeContext);

    const [show, setShow] = React.useState(false);

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("sm"));

    const handleChange = React.useCallback((e) => {
        setShow(true)
        let searchval = remover_acentos_espaco(e.target.value);
        let suggestion = [];
        if (searchval.length > 0) {
            suggestion = lang
                .sort()
                .filter((e) => remover_acentos_espaco(e.descricao).toLowerCase().includes(searchval.toLowerCase()));
            setResfound(suggestion.length !== 0 ? true : false);
        }
        setSuggest(suggestion);
        setSearchtext(searchval);
    }, [lang]);

    const limpar = () => {

        setSearchtext("");
        setSuggest([]);
        setState({...state, servico_id: ''})

    }

    function remover_acentos_espaco(str) {
        return str.normalize("NFD").replace(/[^a-zA-Z\s]+/g, "");
    }

    const getSuggestions = () => {

        if (suggest.length === 0 && searchtext !== "" && !resfound) {
            return <Box display={"flex"} alignItems={"center"} style={{ background: '#FFF', padding: 5, borderRadius: 5 }} mt={1} margin={"0 auto"} width={"95%"}>
                <Cancel color="secondary" fontSize={"small"} />
                <Box ml={1} mr={4}><Typography variant="body2">{"Não foi disponibilizado vagas para o serviço solicitado."}</Typography></Box>
            </Box>
        }

        return (
            <Box mt={0.5} margin={"0 auto"} width={"100%"}>
                <TableContainer component={Paper} size="small">
                    <Table size="small" aria-label="a dense table">
                        <TableBody>
                            {suggest.map((row, index) => (
                                <TableRow key={index} hover style={{ cursor: 'pointer' }}>
                                    <TableCell component="th" scope="row" variant={"body"}>
                                        <Box display={"flex"} alignItems={"center"} 
                                            onClick={() => {
                                                setShow(false)
                                                setState({...state, servico_id: row.id})
                                                setSearchtext(row.descricao)}}>
                                            <Box>
                                                <Typography variant={!matches ? "caption" : "body2"} component="div">
                                                    <Box fontWeight={600}>{row.descricao}</Box>
                                                </Typography>
                                                <Box style={{fontSize: '0.7rem'}}>{row.setor.descricao}</Box>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        );
    };
    return (
        <Box style={{ zIndex: 1001, left: 0, right: 0, position: "relative" }}>
            <Box margin={"0 auto"} width={"100%"}>
                <TextField
                    autoFocus
                    InputProps={{
                        endAdornment:
                            searchtext && <Fab
                                style={{ background: "transparent", boxShadow: "none" }}
                                aria-label="add"
                                size="small"
                                onClick={limpar}
                            >
                                <Clear />
                            </Fab>
                    }}
                    value={searchtext}
                    onChange={handleChange}
                    style={{ background: "rgb(255,255,255,0.9)", borderRadius: 5, width: "100%" }}
                    variant="outlined"
                    placeholder="Que atendimento está procurando?"
                />

            </Box>
            <Box style={{ zIndex: 1001, left: 0, right: 0, position: "absolute", maxHeight: '400px', overflowY: 'auto' }}>
                {show && getSuggestions()}
            </Box>
        </Box>
    );
};
export default Autocomplete;
